export default __webpack_public_path__ + "static/media/GuessJobs2_13.6997fa9e.png";